import { billing } from '@/services/billing';
import { useAddonPurchase } from './use-addon-purchase';

export function useOpenActivityHistoryAddon(): () => Promise<void> {
  const { openAddon } = useAddonPurchase();

  return async () => {
    const purchase = await openAddon({ request: { key: 'activity-history' } });
    if (purchase?.isPurchased === true) {
      await billing.initialize.perform({ refresh: true, ignoreErrors: true });
    }
  };
}
